import React from "react";

const SCORE_STYLES = {
  5:  { bg: '#0a4a2e', text: '#22c55e', border: '#166534', label: 'EXTREME BULL' },
  4:  { bg: '#0a3d26', text: '#22c55e', border: '#15803d', label: 'VERY BULLISH' },
  3:  { bg: '#0a3320', text: '#4ade80', border: '#166534', label: 'BULLISH' },
  2:  { bg: '#0a2a1a', text: '#86efac', border: '#14532d', label: 'LEAN BULL' },
  1:  { bg: '#0a2214', text: '#bbf7d0', border: '#14532d', label: 'SLIGHT BULL' },
  0:  { bg: '#1a1a2e', text: '#94a3b8', border: '#334155', label: 'NEUTRAL' },
  '-1': { bg: '#2a1418', text: '#fca5a5', border: '#7f1d1d', label: 'SLIGHT BEAR' },
  '-2': { bg: '#3a1018', text: '#f87171', border: '#991b1b', label: 'LEAN BEAR' },
  '-3': { bg: '#4a0c14', text: '#ef4444', border: '#b91c1c', label: 'BEARISH' },
  '-4': { bg: '#5a0810', text: '#dc2626', border: '#991b1b', label: 'VERY BEARISH' },
  '-5': { bg: '#6a040c', text: '#dc2626', border: '#7f1d1d', label: 'EXTREME BEAR' },
};

const ScoreBadge = React.memo(function ScoreBadge({ score, label, isExpanded }) {
  const numScore = typeof score === 'number' ? score : parseInt(score) || 0;
  const clamped = Math.max(-5, Math.min(5, numScore));
  const style = SCORE_STYLES[clamped] || SCORE_STYLES[0];
  const displayScore = clamped > 0 ? `+${clamped}` : `${clamped}`;
  const displayLabel = label || style.label;

  return (
    <div
      data-testid="feed-card-score-badge"
      aria-label={`Score ${displayScore} ${displayLabel}`}
      className="inline-flex flex-col items-center justify-center px-3 py-1.5 rounded-[10px] transition-all duration-150"
      style={{
        backgroundColor: style.bg,
        border: `1px solid ${isExpanded ? '#f59e0b' : style.border}`,
        minWidth: '56px',
        boxShadow: isExpanded ? '0 0 8px rgba(245, 158, 11, 0.2)' : 'none',
      }}
    >
      <span
        className="font-mono text-xl font-bold leading-none"
        style={{ color: style.text }}
      >
        {displayScore}
      </span>
      <span
        className="font-mono text-[9px] tracking-[0.14em] uppercase mt-0.5 leading-none"
        style={{ color: style.text, opacity: 0.8 }}
      >
        {displayLabel}
      </span>
    </div>
  );
});

export default ScoreBadge;
